module.exports = __webpack_public_path__ + "img/1_3.244696d5.png";